import type {
  AboutCurrencyInBlockchainDTO,
  AdaptedAboutCurrencyInBlockchainDTO,
} from './currencyTypes'
import type { WalletDTO } from '@/domain/wallet'
import { currencyUtils } from '@/utils'

const { cryptoToBig, formatDynamicCurrency, cryptoToFiat } = currencyUtils

export const adapterGetAboutCurrencyInBlockchain = (
  currencyInBlockchain: AboutCurrencyInBlockchainDTO,
  cryptoWallet: WalletDTO,
): AdaptedAboutCurrencyInBlockchainDTO => {
  const minWithdrawCryptoAmount =
    currencyInBlockchain?.min_withdraw_amount && currencyInBlockchain?.factor
      ? currencyInBlockchain?.min_withdraw_amount / currencyInBlockchain?.factor
      : 0

  // Find the price per unit for the given currency in the wallet
  const cryptoPricePerUnit = cryptoWallet?.completeCurrencies?.find(
    (currency) => currency.code === currencyInBlockchain?.isin,
  )?.pricePerUnit

  const minWithdrawAmountInCryptoFormatted = formatDynamicCurrency({
    currencyCode: currencyInBlockchain?.isin,
    amount: minWithdrawCryptoAmount,
  })

  const minWithdrawAmountInFiat = cryptoToFiat({
    amountCrypto: minWithdrawCryptoAmount,
    cryptoPricePerUnit: cryptoPricePerUnit ?? 0,
  })

  const minWithdrawAmountInFiatFormatted = formatDynamicCurrency({
    currencyCode: cryptoWallet.displayCurrency || 'USD',
    amount: minWithdrawAmountInFiat,
  })

  return {
    ...currencyInBlockchain,
    minWithdrawAmountInCrypto: {
      amount: cryptoToBig({
        amount: minWithdrawCryptoAmount,
      }),
      code: currencyInBlockchain?.isin,
    },
    minWithdrawAmountInCryptoFormatted,
    minWithdrawAmountInFiat: {
      amount: minWithdrawAmountInFiat,
      code: cryptoWallet.displayCurrency || 'USD',
    },
    minWithdrawAmountInFiatFormatted,
  }
}

export const currencyAdapters = {
  adapterGetAboutCurrencyInBlockchain,
}
